import { render, staticRenderFns } from "./CategoryCodeDropdown.vue?vue&type=template&id=12f3b0b7&scoped=true&"
import script from "./CategoryCodeDropdown.vue?vue&type=script&lang=js&"
export * from "./CategoryCodeDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f3b0b7",
  null
  
)

export default component.exports